import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 6h18","key":"svg-0"}],["path",{"d":"M3 12h18","key":"svg-1"}],["path",{"d":"M3 18h18","key":"svg-2"}],["path",{"d":"M6 3v18","key":"svg-3"}],["path",{"d":"M12 3v18","key":"svg-4"}],["path",{"d":"M18 3v18","key":"svg-5"}]]

const IconGrid4x4 = createReactComponent('outline', 'grid-4x4', 'Grid4x4', __iconNode);

export default IconGrid4x4;